import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { lineItemSlug } = useLocalSearchParams<{ lineItemSlug: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Share — {lineItemSlug}</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
